import {
  MAT_NATIVE_DATE_FORMATS,
  MatDateFormats,
} from '@angular/material/core';

export const BASIC_DATE_FORMAT: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    } as Intl.DateTimeFormatOptions,
  },
};

export const MONTH_YEAR_DATE_FORMAT: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: '2-digit',
    } as Intl.DateTimeFormatOptions,
  },
};

export const toMonthYear = (normalizedMonthAndYear: Date): Date => {
  const local = new Date();
  local?.setMonth(normalizedMonthAndYear.getMonth());
  local?.setFullYear(normalizedMonthAndYear.getFullYear());
  local?.setDate(1);

  return new Date(local.getTime());
};

export const formatUTCDate = (date?: Date): string => {
  if (!date) {
    return '';
  }
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};
